export default __webpack_public_path__ + "static/media/dog.99d25bda.png";